// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pingflo-issue,
.pingflo-home {
  --pingflo-field: #0c3d32;
  --pingflo-panel: #f4f7f5;
  --pingflo-amber: #f6c445;
  --pingflo-rubber: #d6453d;
  --pingflo-ink: #12202b;
  --pingflo-blue: #0877bc;
  font-family: Poppins, "Segoe UI", sans-serif;
  color: var(--pingflo-panel);
}

.pingflo-issue {
  min-height: 100%;
  background: var(--pingflo-field);
  padding: 20px 16px 96px;
}

.pingflo-mast {
  display: flex;
  gap: 14px;
  align-items: center;
  margin-bottom: 18px;
}

.pingflo-mast h1,
.pingflo-section h2,
.pingflo-setup h2,
.pingflo-archive h2,
.pingflo-event h3 {
  font-family: Poppins, "Segoe UI", sans-serif;
  font-weight: 600;
  margin: 0;
}

.pingflo-mast h1 {
  font-size: 1.6rem;
  letter-spacing: -0.03em;
}

.pingflo-mast p,
.pingflo-groups {
  margin: 2px 0 0;
}

.pingflo-mark {
  margin: 0;
  color: var(--pingflo-blue);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.pingflo-board,
.pingflo-home ol {
  list-style: none;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin: 0 0 22px;
  padding: 0;
}

.pingflo-figure,
.pingflo-home ol li {
  background: #0a2e26;
  border-radius: 2px;
  padding: 12px 10px 10px;
  min-height: 92px;
}

.pingflo-figure strong,
.pingflo-home ol strong {
  display: block;
  font-family: Teko, "Arial Narrow", Impact, sans-serif;
  font-weight: 600;
  font-size: 3.4rem;
  line-height: 0.85;
  color: var(--pingflo-amber);
  animation: pingflo-count 0.45s ease both;
}

.pingflo-figure span,
.pingflo-home ol span,
.pingflo-figure em {
  display: block;
}

.pingflo-figure span,
.pingflo-home ol span {
  margin-top: 6px;
  font-size: 0.72rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.pingflo-figure em {
  margin-top: 4px;
  font-style: normal;
  color: var(--pingflo-amber);
  font-weight: 600;
}

.pingflo-section,
.pingflo-setup,
.pingflo-archive,
.pingflo-empty,
.pingflo-banner,
.pingflo-error {
  background: var(--pingflo-panel);
  color: var(--pingflo-ink);
  border-radius: 2px;
  padding: 14px 14px 10px;
  margin: 0 0 12px;
}

.pingflo-section h2,
.pingflo-archive h2,
.pingflo-setup h2 {
  font-size: 0.78rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  margin-bottom: 10px;
}

.pingflo-weeks,
.pingflo-matches,
.pingflo-results,
.pingflo-activity,
.pingflo-archive ul,
.pingflo-podium {
  list-style: none;
  margin: 0;
  padding: 0;
}

.pingflo-weeks > li + li,
.pingflo-event + .pingflo-event {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid rgba(18, 32, 43, 0.12);
}

.pingflo-week-date {
  margin: 0 0 6px;
  font-size: 0.85rem;
  font-weight: 600;
}

.pingflo-weeks ul li,
.pingflo-matches li,
.pingflo-results li,
.pingflo-activity li {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 10px;
  align-items: baseline;
  padding: 6px 0;
}

.pingflo-name {
  font-weight: 600;
}

.pingflo-name b {
  font-family: Teko, "Arial Narrow", sans-serif;
  font-size: 1.6rem;
  font-weight: 600;
  margin: 0 6px;
  color: var(--pingflo-ink);
}

.pingflo-metric,
.pingflo-outcome,
.pingflo-group {
  font-size: 0.85rem;
}

.pingflo-metric.is-pb,
.pingflo-outcome.is-win {
  color: var(--pingflo-rubber);
  font-weight: 700;
}

.pingflo-outcome.is-loss {
  color: #5c6b73;
}

.pingflo-group,
.pingflo-quiet {
  color: #5c6b73;
}

.pingflo-podium {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.pingflo-podium li {
  display: flex;
  align-items: baseline;
  gap: 8px;
  background: #e7eeea;
  padding: 8px 10px;
}

.pingflo-podium b {
  font-family: Teko, "Arial Narrow", sans-serif;
  font-size: 2rem;
  line-height: 0.8;
  color: var(--pingflo-amber);
  background: var(--pingflo-field);
  padding: 4px 7px 2px;
}

.pingflo-event header p,
.pingflo-quiet {
  margin: 2px 0 8px;
}

.pingflo-setup label,
.pingflo-check {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 10px;
  font-size: 0.9rem;
}

.pingflo-check {
  flex-direction: row;
  align-items: center;
}

.pingflo-setup input,
.pingflo-setup select {
  font: inherit;
  padding: 8px;
  border: 1px solid rgba(18, 32, 43, 0.25);
  background: #fff;
  color: var(--pingflo-ink);
}

.pingflo-setup fieldset {
  border: 0;
  margin: 0 0 8px;
  padding: 0;
}

.pingflo-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.pingflo-actions button,
.pingflo-setup-toggle {
  font: inherit;
  font-weight: 600;
  border: 0;
  background: var(--pingflo-field);
  color: var(--pingflo-panel);
  padding: 10px 12px;
  cursor: pointer;
}

.pingflo-actions button.is-send,
.pingflo-setup-toggle {
  background: var(--pingflo-amber);
  color: var(--pingflo-ink);
}

.pingflo-actions button:disabled {
  opacity: 0.55;
  cursor: default;
}

.pingflo-setup-toggle {
  margin: 0 0 12px;
}

.pingflo-error {
  color: var(--pingflo-rubber);
  background: #fff4f2;
}

.pingflo-banner {
  background: var(--pingflo-amber);
  color: var(--pingflo-ink);
  font-weight: 600;
}

.pingflo-archive a {
  color: var(--pingflo-blue);
  font-weight: 600;
}

.pingflo-archive a[aria-current="page"] {
  text-decoration: none;
  color: var(--pingflo-ink);
}

.pingflo-home {
  display: block;
  text-decoration: none;
  background: var(--pingflo-field);
  margin: 12px 16px;
  padding: 14px;
  border-radius: 2px;
}

.pingflo-home-range {
  margin: 2px 0 10px;
  font-weight: 600;
}

.pingflo-home ol {
  margin: 0;
}

.pingflo-home ol li {
  min-height: 0;
  padding: 8px;
}

.pingflo-home ol strong {
  font-size: 2.4rem;
}

/* Call for players: the one block that asks the reader to act. */
.pingflo-call {
  background: var(--pingflo-amber);
  color: var(--pingflo-ink);
  border-radius: 2px;
  padding: 14px;
  margin: 0 0 12px;
}

.pingflo-call h2 {
  margin: 0 0 8px;
  font-family: Teko, "Arial Narrow", Impact, sans-serif;
  font-size: 1.9rem;
  font-weight: 600;
  line-height: 0.9;
  text-transform: uppercase;
}

.pingflo-call ul,
.pingflo-fixtures,
.pingflo-lineup,
.pingflo-month-strip,
.pingflo-post-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.pingflo-call li {
  display: flex;
  flex-wrap: wrap;
  gap: 2px 10px;
  align-items: baseline;
  padding: 6px 0;
  border-top: 1px solid rgba(18, 32, 43, 0.18);
}

.pingflo-call-when {
  font-size: 0.85rem;
}

.pingflo-call-cta {
  display: inline-block;
  margin-top: 10px;
  padding: 10px 14px;
  background: var(--pingflo-field);
  color: var(--pingflo-panel);
  font-weight: 700;
  text-decoration: none;
}

.pingflo-call-cta:focus-visible,
.pingflo-post-media:focus-visible {
  outline: 3px solid var(--pingflo-blue);
  outline-offset: 2px;
}

/* Month so far */
.pingflo-month-strip {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(84px, 1fr));
  gap: 6px;
  margin-bottom: 8px;
}

.pingflo-month-strip li {
  background: var(--pingflo-field);
  color: var(--pingflo-panel);
  padding: 8px;
}

.pingflo-month-strip strong {
  display: block;
  font-family: Teko, "Arial Narrow", Impact, sans-serif;
  font-size: 2rem;
  font-weight: 600;
  line-height: 0.9;
  color: var(--pingflo-amber);
}

.pingflo-month-strip span {
  font-size: 0.68rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

/* Fixtures and line-ups */
.pingflo-fixtures > li + li {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(18, 32, 43, 0.12);
}

.pingflo-fixtures h3 {
  margin: 0 0 6px;
  font-size: 1rem;
  font-weight: 600;
}

.pingflo-fixture-when {
  margin: 0 0 2px;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--pingflo-blue);
}

.pingflo-fixtures a,
.pingflo-post a,
.pingflo-public-foot a {
  color: var(--pingflo-blue);
  font-weight: 600;
}

.pingflo-lineup {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.pingflo-lineup li {
  display: inline-flex;
  gap: 6px;
  align-items: baseline;
  background: #e7eeea;
  padding: 4px 8px;
  font-size: 0.88rem;
}

.pingflo-lineup li.is-in {
  background: #dcefe4;
}

.pingflo-lineup li.is-out {
  text-decoration: line-through;
  opacity: 0.6;
}

.pingflo-lineup small {
  color: #5c6b73;
}

.pingflo-lineup-ok {
  color: #1d7a4c;
  font-weight: 700;
}

/* Posts */
.pingflo-post + .pingflo-post {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid rgba(18, 32, 43, 0.12);
}

.pingflo-post.is-pinned {
  border-left: 4px solid var(--pingflo-amber);
  padding-left: 10px;
}

.pingflo-post h3 {
  margin: 8px 0 4px;
  font-size: 1.05rem;
  font-weight: 600;
}

.pingflo-post-body {
  margin: 0 0 6px;
  white-space: pre-line;
}

.pingflo-post-author {
  margin: 4px 0 0;
  font-size: 0.8rem;
  color: #5c6b73;
}

.pingflo-post-image,
.pingflo-post-media img {
  display: block;
  width: 100%;
  max-height: 320px;
  object-fit: cover;
}

.pingflo-post-media {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  border: 0;
  background: #000;
  cursor: pointer;
}

.pingflo-post-play {
  position: absolute;
  inset: 50% auto auto 50%;
  transform: translate(-50%, -50%);
  width: 56px;
  height: 56px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: var(--pingflo-amber);
  color: var(--pingflo-ink);
  font-size: 1.3rem;
}

.pingflo-post-video {
  position: relative;
  aspect-ratio: 16 / 9;
}

.pingflo-post-video iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

/* Staff tools */
.pingflo-toolbar,
.pingflo-presets,
.pingflo-issue-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 0 12px;
}

.pingflo-toolbar .pingflo-setup-toggle {
  margin: 0;
  background: transparent;
  color: var(--pingflo-panel);
  box-shadow: inset 0 0 0 1px rgba(244, 247, 245, 0.4);
}

.pingflo-toolbar .pingflo-setup-toggle[aria-pressed="true"] {
  background: var(--pingflo-amber);
  color: var(--pingflo-ink);
  box-shadow: none;
}

.pingflo-presets button,
.pingflo-issue-meta button,
.pingflo-post-actions button,
.pingflo-link-preview button {
  font: inherit;
  font-size: 0.85rem;
  border: 1px solid currentColor;
  background: transparent;
  color: inherit;
  padding: 6px 10px;
  cursor: pointer;
}

.pingflo-issue-meta {
  align-items: center;
  font-size: 0.88rem;
}

.pingflo-error-inline {
  color: #ffb0a8;
  font-weight: 600;
}

.pingflo-setup textarea {
  font: inherit;
  padding: 8px;
  border: 1px solid rgba(18, 32, 43, 0.25);
  background: #fff;
  color: var(--pingflo-ink);
  resize: vertical;
}

.pingflo-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0 10px;
}

.pingflo-row > label {
  flex: 1 1 160px;
}

.pingflo-row > label.pingflo-narrow {
  flex: 0 1 96px;
}

.pingflo-recipients {
  background: #e7eeea;
  padding: 10px;
  margin-bottom: 10px;
}

.pingflo-recipients p {
  margin: 0;
}

.pingflo-link-preview {
  display: flex;
  gap: 10px;
  align-items: center;
  background: #e7eeea;
  padding: 8px;
  margin-bottom: 10px;
}

.pingflo-link-preview img {
  width: 96px;
  height: 64px;
  object-fit: cover;
  flex: none;
}

.pingflo-link-preview div {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.pingflo-subhead {
  margin: 16px 0 6px;
  font-size: 0.78rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.pingflo-post-list li {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 8px;
  align-items: center;
  padding: 8px 0;
  border-top: 1px solid rgba(18, 32, 43, 0.12);
}

.pingflo-chip {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  background: var(--pingflo-field);
  color: var(--pingflo-panel);
  padding: 2px 6px;
}

.pingflo-chip.is-pin {
  background: var(--pingflo-amber);
  color: var(--pingflo-ink);
}

.pingflo-post-actions {
  display: flex;
  gap: 6px;
  margin-left: auto;
}

.pingflo-public-foot {
  text-align: center;
  margin: 18px 0 0;
}

.pingflo-public-foot a {
  color: var(--pingflo-amber);
}

.pingflo-issue.is-public {
  max-width: 720px;
  margin: 0 auto;
  min-height: 100vh;
}

@keyframes pingflo-count {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@media (min-width: 720px) {
  .pingflo-issue {
    padding: 28px 28px 96px;
  }

  .pingflo-board,
  .pingflo-home ol {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (prefers-reduced-motion: reduce) {
  .pingflo-figure strong,
  .pingflo-home ol strong {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/newsletter/PingfloNewsletterPage.css"],"names":[],"mappings":"AAAA;;EAEE,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;;;EAKE,4CAA4C;EAC5C,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,qDAAqD;EACrD,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;;;;;EAME,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;;EAGE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;;;;;EAME,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;EAIE,aAAa;EACb,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;EAC7C,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;EAEE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ,wCAAwC;EACxC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,gCAAgC;EAChC,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gCAAgC;EAChC,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA,iEAAiE;AACjE;EACE,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qDAAqD;EACrD,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;;;;EAKE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,0DAA0D;EAC1D,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA,gBAAgB;AAChB;;;EAGE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;;;EAIE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,wCAAwC;EACxC,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;;IAEE,qCAAqC;EACvC;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF","sourcesContent":[".pingflo-issue,\n.pingflo-home {\n  --pingflo-field: #0c3d32;\n  --pingflo-panel: #f4f7f5;\n  --pingflo-amber: #f6c445;\n  --pingflo-rubber: #d6453d;\n  --pingflo-ink: #12202b;\n  --pingflo-blue: #0877bc;\n  font-family: Poppins, \"Segoe UI\", sans-serif;\n  color: var(--pingflo-panel);\n}\n\n.pingflo-issue {\n  min-height: 100%;\n  background: var(--pingflo-field);\n  padding: 20px 16px 96px;\n}\n\n.pingflo-mast {\n  display: flex;\n  gap: 14px;\n  align-items: center;\n  margin-bottom: 18px;\n}\n\n.pingflo-mast h1,\n.pingflo-section h2,\n.pingflo-setup h2,\n.pingflo-archive h2,\n.pingflo-event h3 {\n  font-family: Poppins, \"Segoe UI\", sans-serif;\n  font-weight: 600;\n  margin: 0;\n}\n\n.pingflo-mast h1 {\n  font-size: 1.6rem;\n  letter-spacing: -0.03em;\n}\n\n.pingflo-mast p,\n.pingflo-groups {\n  margin: 2px 0 0;\n}\n\n.pingflo-mark {\n  margin: 0;\n  color: var(--pingflo-blue);\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n}\n\n.pingflo-board,\n.pingflo-home ol {\n  list-style: none;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin: 0 0 22px;\n  padding: 0;\n}\n\n.pingflo-figure,\n.pingflo-home ol li {\n  background: #0a2e26;\n  border-radius: 2px;\n  padding: 12px 10px 10px;\n  min-height: 92px;\n}\n\n.pingflo-figure strong,\n.pingflo-home ol strong {\n  display: block;\n  font-family: Teko, \"Arial Narrow\", Impact, sans-serif;\n  font-weight: 600;\n  font-size: 3.4rem;\n  line-height: 0.85;\n  color: var(--pingflo-amber);\n  animation: pingflo-count 0.45s ease both;\n}\n\n.pingflo-figure span,\n.pingflo-home ol span,\n.pingflo-figure em {\n  display: block;\n}\n\n.pingflo-figure span,\n.pingflo-home ol span {\n  margin-top: 6px;\n  font-size: 0.72rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.pingflo-figure em {\n  margin-top: 4px;\n  font-style: normal;\n  color: var(--pingflo-amber);\n  font-weight: 600;\n}\n\n.pingflo-section,\n.pingflo-setup,\n.pingflo-archive,\n.pingflo-empty,\n.pingflo-banner,\n.pingflo-error {\n  background: var(--pingflo-panel);\n  color: var(--pingflo-ink);\n  border-radius: 2px;\n  padding: 14px 14px 10px;\n  margin: 0 0 12px;\n}\n\n.pingflo-section h2,\n.pingflo-archive h2,\n.pingflo-setup h2 {\n  font-size: 0.78rem;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  margin-bottom: 10px;\n}\n\n.pingflo-weeks,\n.pingflo-matches,\n.pingflo-results,\n.pingflo-activity,\n.pingflo-archive ul,\n.pingflo-podium {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.pingflo-weeks > li + li,\n.pingflo-event + .pingflo-event {\n  margin-top: 14px;\n  padding-top: 12px;\n  border-top: 1px solid rgba(18, 32, 43, 0.12);\n}\n\n.pingflo-week-date {\n  margin: 0 0 6px;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.pingflo-weeks ul li,\n.pingflo-matches li,\n.pingflo-results li,\n.pingflo-activity li {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 10px;\n  align-items: baseline;\n  padding: 6px 0;\n}\n\n.pingflo-name {\n  font-weight: 600;\n}\n\n.pingflo-name b {\n  font-family: Teko, \"Arial Narrow\", sans-serif;\n  font-size: 1.6rem;\n  font-weight: 600;\n  margin: 0 6px;\n  color: var(--pingflo-ink);\n}\n\n.pingflo-metric,\n.pingflo-outcome,\n.pingflo-group {\n  font-size: 0.85rem;\n}\n\n.pingflo-metric.is-pb,\n.pingflo-outcome.is-win {\n  color: var(--pingflo-rubber);\n  font-weight: 700;\n}\n\n.pingflo-outcome.is-loss {\n  color: #5c6b73;\n}\n\n.pingflo-group,\n.pingflo-quiet {\n  color: #5c6b73;\n}\n\n.pingflo-podium {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.pingflo-podium li {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  background: #e7eeea;\n  padding: 8px 10px;\n}\n\n.pingflo-podium b {\n  font-family: Teko, \"Arial Narrow\", sans-serif;\n  font-size: 2rem;\n  line-height: 0.8;\n  color: var(--pingflo-amber);\n  background: var(--pingflo-field);\n  padding: 4px 7px 2px;\n}\n\n.pingflo-event header p,\n.pingflo-quiet {\n  margin: 2px 0 8px;\n}\n\n.pingflo-setup label,\n.pingflo-check {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 10px;\n  font-size: 0.9rem;\n}\n\n.pingflo-check {\n  flex-direction: row;\n  align-items: center;\n}\n\n.pingflo-setup input,\n.pingflo-setup select {\n  font: inherit;\n  padding: 8px;\n  border: 1px solid rgba(18, 32, 43, 0.25);\n  background: #fff;\n  color: var(--pingflo-ink);\n}\n\n.pingflo-setup fieldset {\n  border: 0;\n  margin: 0 0 8px;\n  padding: 0;\n}\n\n.pingflo-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.pingflo-actions button,\n.pingflo-setup-toggle {\n  font: inherit;\n  font-weight: 600;\n  border: 0;\n  background: var(--pingflo-field);\n  color: var(--pingflo-panel);\n  padding: 10px 12px;\n  cursor: pointer;\n}\n\n.pingflo-actions button.is-send,\n.pingflo-setup-toggle {\n  background: var(--pingflo-amber);\n  color: var(--pingflo-ink);\n}\n\n.pingflo-actions button:disabled {\n  opacity: 0.55;\n  cursor: default;\n}\n\n.pingflo-setup-toggle {\n  margin: 0 0 12px;\n}\n\n.pingflo-error {\n  color: var(--pingflo-rubber);\n  background: #fff4f2;\n}\n\n.pingflo-banner {\n  background: var(--pingflo-amber);\n  color: var(--pingflo-ink);\n  font-weight: 600;\n}\n\n.pingflo-archive a {\n  color: var(--pingflo-blue);\n  font-weight: 600;\n}\n\n.pingflo-archive a[aria-current=\"page\"] {\n  text-decoration: none;\n  color: var(--pingflo-ink);\n}\n\n.pingflo-home {\n  display: block;\n  text-decoration: none;\n  background: var(--pingflo-field);\n  margin: 12px 16px;\n  padding: 14px;\n  border-radius: 2px;\n}\n\n.pingflo-home-range {\n  margin: 2px 0 10px;\n  font-weight: 600;\n}\n\n.pingflo-home ol {\n  margin: 0;\n}\n\n.pingflo-home ol li {\n  min-height: 0;\n  padding: 8px;\n}\n\n.pingflo-home ol strong {\n  font-size: 2.4rem;\n}\n\n/* Call for players: the one block that asks the reader to act. */\n.pingflo-call {\n  background: var(--pingflo-amber);\n  color: var(--pingflo-ink);\n  border-radius: 2px;\n  padding: 14px;\n  margin: 0 0 12px;\n}\n\n.pingflo-call h2 {\n  margin: 0 0 8px;\n  font-family: Teko, \"Arial Narrow\", Impact, sans-serif;\n  font-size: 1.9rem;\n  font-weight: 600;\n  line-height: 0.9;\n  text-transform: uppercase;\n}\n\n.pingflo-call ul,\n.pingflo-fixtures,\n.pingflo-lineup,\n.pingflo-month-strip,\n.pingflo-post-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.pingflo-call li {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2px 10px;\n  align-items: baseline;\n  padding: 6px 0;\n  border-top: 1px solid rgba(18, 32, 43, 0.18);\n}\n\n.pingflo-call-when {\n  font-size: 0.85rem;\n}\n\n.pingflo-call-cta {\n  display: inline-block;\n  margin-top: 10px;\n  padding: 10px 14px;\n  background: var(--pingflo-field);\n  color: var(--pingflo-panel);\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.pingflo-call-cta:focus-visible,\n.pingflo-post-media:focus-visible {\n  outline: 3px solid var(--pingflo-blue);\n  outline-offset: 2px;\n}\n\n/* Month so far */\n.pingflo-month-strip {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(84px, 1fr));\n  gap: 6px;\n  margin-bottom: 8px;\n}\n\n.pingflo-month-strip li {\n  background: var(--pingflo-field);\n  color: var(--pingflo-panel);\n  padding: 8px;\n}\n\n.pingflo-month-strip strong {\n  display: block;\n  font-family: Teko, \"Arial Narrow\", Impact, sans-serif;\n  font-size: 2rem;\n  font-weight: 600;\n  line-height: 0.9;\n  color: var(--pingflo-amber);\n}\n\n.pingflo-month-strip span {\n  font-size: 0.68rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n/* Fixtures and line-ups */\n.pingflo-fixtures > li + li {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid rgba(18, 32, 43, 0.12);\n}\n\n.pingflo-fixtures h3 {\n  margin: 0 0 6px;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.pingflo-fixture-when {\n  margin: 0 0 2px;\n  font-size: 0.78rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--pingflo-blue);\n}\n\n.pingflo-fixtures a,\n.pingflo-post a,\n.pingflo-public-foot a {\n  color: var(--pingflo-blue);\n  font-weight: 600;\n}\n\n.pingflo-lineup {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.pingflo-lineup li {\n  display: inline-flex;\n  gap: 6px;\n  align-items: baseline;\n  background: #e7eeea;\n  padding: 4px 8px;\n  font-size: 0.88rem;\n}\n\n.pingflo-lineup li.is-in {\n  background: #dcefe4;\n}\n\n.pingflo-lineup li.is-out {\n  text-decoration: line-through;\n  opacity: 0.6;\n}\n\n.pingflo-lineup small {\n  color: #5c6b73;\n}\n\n.pingflo-lineup-ok {\n  color: #1d7a4c;\n  font-weight: 700;\n}\n\n/* Posts */\n.pingflo-post + .pingflo-post {\n  margin-top: 14px;\n  padding-top: 14px;\n  border-top: 1px solid rgba(18, 32, 43, 0.12);\n}\n\n.pingflo-post.is-pinned {\n  border-left: 4px solid var(--pingflo-amber);\n  padding-left: 10px;\n}\n\n.pingflo-post h3 {\n  margin: 8px 0 4px;\n  font-size: 1.05rem;\n  font-weight: 600;\n}\n\n.pingflo-post-body {\n  margin: 0 0 6px;\n  white-space: pre-line;\n}\n\n.pingflo-post-author {\n  margin: 4px 0 0;\n  font-size: 0.8rem;\n  color: #5c6b73;\n}\n\n.pingflo-post-image,\n.pingflo-post-media img {\n  display: block;\n  width: 100%;\n  max-height: 320px;\n  object-fit: cover;\n}\n\n.pingflo-post-media {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  border: 0;\n  background: #000;\n  cursor: pointer;\n}\n\n.pingflo-post-play {\n  position: absolute;\n  inset: 50% auto auto 50%;\n  transform: translate(-50%, -50%);\n  width: 56px;\n  height: 56px;\n  display: grid;\n  place-items: center;\n  border-radius: 50%;\n  background: var(--pingflo-amber);\n  color: var(--pingflo-ink);\n  font-size: 1.3rem;\n}\n\n.pingflo-post-video {\n  position: relative;\n  aspect-ratio: 16 / 9;\n}\n\n.pingflo-post-video iframe {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n\n/* Staff tools */\n.pingflo-toolbar,\n.pingflo-presets,\n.pingflo-issue-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 0 0 12px;\n}\n\n.pingflo-toolbar .pingflo-setup-toggle {\n  margin: 0;\n  background: transparent;\n  color: var(--pingflo-panel);\n  box-shadow: inset 0 0 0 1px rgba(244, 247, 245, 0.4);\n}\n\n.pingflo-toolbar .pingflo-setup-toggle[aria-pressed=\"true\"] {\n  background: var(--pingflo-amber);\n  color: var(--pingflo-ink);\n  box-shadow: none;\n}\n\n.pingflo-presets button,\n.pingflo-issue-meta button,\n.pingflo-post-actions button,\n.pingflo-link-preview button {\n  font: inherit;\n  font-size: 0.85rem;\n  border: 1px solid currentColor;\n  background: transparent;\n  color: inherit;\n  padding: 6px 10px;\n  cursor: pointer;\n}\n\n.pingflo-issue-meta {\n  align-items: center;\n  font-size: 0.88rem;\n}\n\n.pingflo-error-inline {\n  color: #ffb0a8;\n  font-weight: 600;\n}\n\n.pingflo-setup textarea {\n  font: inherit;\n  padding: 8px;\n  border: 1px solid rgba(18, 32, 43, 0.25);\n  background: #fff;\n  color: var(--pingflo-ink);\n  resize: vertical;\n}\n\n.pingflo-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0 10px;\n}\n\n.pingflo-row > label {\n  flex: 1 1 160px;\n}\n\n.pingflo-row > label.pingflo-narrow {\n  flex: 0 1 96px;\n}\n\n.pingflo-recipients {\n  background: #e7eeea;\n  padding: 10px;\n  margin-bottom: 10px;\n}\n\n.pingflo-recipients p {\n  margin: 0;\n}\n\n.pingflo-link-preview {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  background: #e7eeea;\n  padding: 8px;\n  margin-bottom: 10px;\n}\n\n.pingflo-link-preview img {\n  width: 96px;\n  height: 64px;\n  object-fit: cover;\n  flex: none;\n}\n\n.pingflo-link-preview div {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.pingflo-subhead {\n  margin: 16px 0 6px;\n  font-size: 0.78rem;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n.pingflo-post-list li {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 8px;\n  align-items: center;\n  padding: 8px 0;\n  border-top: 1px solid rgba(18, 32, 43, 0.12);\n}\n\n.pingflo-chip {\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  background: var(--pingflo-field);\n  color: var(--pingflo-panel);\n  padding: 2px 6px;\n}\n\n.pingflo-chip.is-pin {\n  background: var(--pingflo-amber);\n  color: var(--pingflo-ink);\n}\n\n.pingflo-post-actions {\n  display: flex;\n  gap: 6px;\n  margin-left: auto;\n}\n\n.pingflo-public-foot {\n  text-align: center;\n  margin: 18px 0 0;\n}\n\n.pingflo-public-foot a {\n  color: var(--pingflo-amber);\n}\n\n.pingflo-issue.is-public {\n  max-width: 720px;\n  margin: 0 auto;\n  min-height: 100vh;\n}\n\n@keyframes pingflo-count {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n@media (min-width: 720px) {\n  .pingflo-issue {\n    padding: 28px 28px 96px;\n  }\n\n  .pingflo-board,\n  .pingflo-home ol {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .pingflo-figure strong,\n  .pingflo-home ol strong {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
